import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const Stars = ({ value }) => (
  <div className="flex items-center gap-0.5" aria-label={`${value} stelle`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`w-3.5 h-3.5 ${i < value ? "text-arabell-gold fill-arabell-gold" : "text-white/15"}`}
        strokeWidth={1.2}
      />
    ))}
  </div>
);

const ReviewsSection = () => {
  const [featured, setFeatured] = useState([]);
  const [stats, setStats] = useState({ total: 0, average: 0 });

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/reviews?limit=24`);
        const data = await res.json();
        setStats({ total: data.total, average: data.average });
        const fiveStars = data.items.filter((r) => r.rating === 5).slice(0, 6);
        setFeatured(fiveStars.length === 6 ? fiveStars : data.items.slice(0, 6));
      } catch (e) {
        console.error("Failed to load reviews", e);
      }
    })();
  }, []);

  if (featured.length === 0) return null;

  return (
    <section
      id="recensioni"
      data-testid="home-reviews-section"
      className="relative bg-black border-t border-white/10 py-20 md:py-28"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-[10px] md:text-xs tracking-[0.5em] uppercase text-arabell-gold mb-4">
            Voices from our clients
          </p>
          <h2 className="font-display text-3xl md:text-5xl text-white tracking-[0.12em] uppercase mb-6">
            Recensioni
          </h2>
          <div className="w-14 h-px bg-arabell-gold mx-auto mb-6" />
          <div className="flex items-center justify-center gap-4 text-white/70">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-5 h-5 text-arabell-gold fill-arabell-gold" strokeWidth={1.2} />
              ))}
            </div>
            <span className="text-sm tracking-[0.25em] uppercase">
              {stats.average} · {stats.total} recensioni verificate
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((r) => (
            <article
              key={r.id}
              data-testid={`review-card-${r.id}`}
              className="bg-[#0a0a0a] border border-white/5 hover:border-arabell-gold/40 transition-colors duration-500 p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-arabell-gold/10 border border-arabell-gold/30 flex items-center justify-center text-arabell-gold text-sm tracking-wider">
                    {r.initial}
                  </div>
                  <div>
                    <p className="text-white text-sm tracking-wide">{r.name}</p>
                    <p className="text-[10px] tracking-[0.25em] uppercase text-white/40">
                      {r.location}
                    </p>
                  </div>
                </div>
                <Stars value={r.rating} />
              </div>
              <p dir="auto" className="text-white/75 text-sm leading-relaxed mb-5 flex-1">"{r.text}"</p>
              <div className="pt-4 border-t border-white/10 flex items-center justify-between">
                <span className="text-[10px] tracking-[0.3em] uppercase text-arabell-gold/80">
                  {r.service}
                </span>
                <span className="text-[10px] tracking-[0.25em] uppercase text-white/40">
                  {r.date}
                </span>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-14">
          <Link
            to="/recensioni"
            data-testid="view-all-reviews-link"
            className="inline-block px-8 py-3 text-[11px] tracking-[0.35em] uppercase bg-white text-black hover:bg-arabell-gold transition-colors duration-300"
          >
            Leggi tutte le recensioni
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
